var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SearchBanner",
    {
      attrs: {
        "store-namespace": "hotelsSearchBanner",
        id: _vm.id,
        title: _vm.$t("10034053.Home_TitleDateSearch"),
        description: _vm.$t("10034054.Home_SearchHotelDate"),
        "image-src": _vm.image,
      },
    },
    [
      _c("SearchBannerForm", {
        attrs: {
          "store-namespace": "hotelsSearchBanner",
          id: _vm.id + "-form",
          labels: {
            city: _vm.$t("10034055.Home_InputDestination"),
            cityDrawer: _vm.$t(
              "43943.InspirationsClient_HotelsLocationDrawerTitle"
            ),
            date: _vm.$t("10034056.Home_InputDate"),
            dateDrawer: _vm.$t(
              "43944.InspirationsClient_HotelsDateDrawerTitle"
            ),
            amount: _vm.$t("10034057.Home_InputRooms"),
            amountDrawer: _vm.$t(
              "43945.InspirationsClient_HotelsRoomsDrawerTitle"
            ),
            submit: _vm.$t("10034060.Home_ButtonHotelSearch"),
          },
          "calendar-config": {
            type: "hotel",
            flow: "hotel-search-bar-date-range-calendar",
          },
        },
        on: { submit: _vm.handleSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }